/**
 * Moves the account link and social buttons into Horizon's mobile menu drawer.
 *
 * Horizon's drawer has no block slot, and the theme's own Liquid must not be
 * edited, so the markup is rendered (hidden) by sections/sfk-topbar.liquid and
 * relocated here. Nothing is built in JavaScript — this only moves a node, so
 * the links keep their real URLs, labels and translations.
 *
 * Everything is defensive: if Horizon renames a class the move is skipped and
 * the drawer carries on working. The markup stays hidden in that case.
 */
(function () {
  const EXTRAS = '[data-sfk-drawer-extras]';
  const UTILITY = '.menu-drawer__utility-links';
  const DRAWER = '.menu-drawer';

  function place() {
    const extras = document.querySelector(EXTRAS);
    if (!extras || extras.dataset.sfkPlaced === 'true') return;

    // Prefer Horizon's own utility region so the drawer's staggered reveal
    // animation carries the extras in too.
    const host = document.querySelector(UTILITY) || document.querySelector(DRAWER);
    if (!host) return;

    host.appendChild(extras);
    extras.hidden = false;
    extras.dataset.sfkPlaced = 'true';
  }

  function watch() {
    place();
    if (document.querySelector(EXTRAS + '[data-sfk-placed="true"]')) return;

    // The drawer can be re-rendered by the Section Rendering API (and by the
    // theme editor), so retry until it settles, then stop observing.
    const observer = new MutationObserver(() => {
      place();
      if (document.querySelector(EXTRAS + '[data-sfk-placed="true"]')) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Belt and braces: stop watching after ten seconds either way.
    window.setTimeout(() => observer.disconnect(), 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else {
    watch();
  }

  // The theme editor swaps section markup wholesale; re-place afterwards.
  document.addEventListener('shopify:section:load', () => {
    const extras = document.querySelector(EXTRAS);
    if (extras) delete extras.dataset.sfkPlaced;
    watch();
  });
})();
